import { Injectable } from '@angular/core';

import { PedidoItem } from '../pedido-item';

@Injectable({
    providedIn: 'root'
})
export class PedidoItemSequenciaService {

    /** Ordena os itens do pedido */
    sort(entities: PedidoItem[]): PedidoItem[] {
        if (!entities) {
            return [];
        }
        return entities.sort((itemA, itemB) => itemA.sequencia - itemB.sequencia);
    }

    /** Obtem a próxima sequência para os itens do Pedido */
    getProximaSequencia(entities: PedidoItem[]): number {
        if (!entities || entities.length === 0) {
            return 1;
        }

        // Ordenando pela sequência
        const entitiesSorted = this.sort(entities);
        const ultimaSequencia = entitiesSorted[entitiesSorted.length - 1].sequencia;
        return ultimaSequencia + 1;
    }

    /** Atualiza a sequência dos itens do Pedido */
    atualizar(entities: PedidoItem[]) {
        entities = this.sort(entities);
        let seq = 1;
        entities.forEach(entity => {
            entity.sequencia = seq;
            seq++;
        })
    }
}
